import PdfViewer from './detail';

/**
 * Init and load PDFViewer
 */
window.addEventListener('DOMContentLoaded', () => {
    const pdfViewer = new PdfViewer(window.__VUMEDI_PDF__);
    pdfViewer.load();
});
